export const actionTypes = {
  GET_TIMERSETTINGS: "timerSettings/getTimerSettings",
  PUT_TIMERSETTINGS: "timerSettings/putTimerSettings",
};
